/** Map profile/settings language labels to BCP-47 tags for live streaming STT. */
const LANGUAGE_LABEL_TO_BCP47 = {
  english: "en-US",
  spanish: "es-ES",
  french: "fr-FR",
  german: "de-DE",
  italian: "it-IT",
  portuguese: "pt-BR",
  mandarin: "zh-CN",
  chinese: "zh-CN",
  japanese: "ja-JP",
  korean: "ko-KR",
  russian: "ru-RU",
  arabic: "ar-SA",
  hindi: "hi-IN",
  vietnamese: "vi-VN",
  thai: "th-TH",
  dutch: "nl-NL",
  polish: "pl-PL",
  swedish: "sv-SE",
  indonesian: "id-ID",
};

function normalizeLanguageLabel(label) {
  if (label == null) return "";
  const s = String(label).trim().toLowerCase();
  if (!s) return "";
  const paren = s.match(/\(([^)]+)\)/);
  if (paren && paren[1]) return paren[1].trim().toLowerCase();
  return s.split(/[\s(/]/)[0] || s;
}

function labelToBcp47(label) {
  const key = normalizeLanguageLabel(label);
  if (!key) return null;
  if (/^[a-z]{2}(-[a-z]{2})?$/i.test(key)) {
    const [lang, region] = key.split("-");
    return region ? `${lang.toLowerCase()}-${region.toUpperCase()}` : `${lang.toLowerCase()}-US`;
  }
  return LANGUAGE_LABEL_TO_BCP47[key] || null;
}

/**
 * Resolve Socket.IO streaming locale from profile defaultInputLanguages (or legacy profile.language).
 * Returns "multi" for English+Spanish (or any multi-language list), else a single BCP-47 tag.
 */
export function resolveLiveStreamingLocale(inputLanguages, fallbackLanguage) {
  let langs = Array.isArray(inputLanguages) ? inputLanguages.filter(Boolean) : [];
  if (langs.length === 0 && fallbackLanguage) {
    langs = [fallbackLanguage];
  }
  if (langs.length === 0) return "en-US";

  const bcp47 = langs.map(labelToBcp47).filter(Boolean);
  const unique = [...new Set(bcp47)];

  if (unique.length === 0) return "en-US";
  if (unique.length === 1) return unique[0];
  return "multi";
}
